import
{
  Checkbox,
  FormControlLabel,
  FormGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Title } from "../../../../../stories/Title/Title";
import { Operation, TableHeaders } from "../../../../../utils/Enum.types";
import { Button } from "../../../../../stories/Button/Button";
import { useEffect, useMemo, useState } from "react";
import FileAttach from "../../../../../images/BrowseFiles.svg";
import DownArrow from "../../../../../images/DownArrow.svg";
import TotalStudents from "../../../../../images/TotalMale.svg";
import ReadyToImport from "../../../../../images/Present.svg";
import ContainsError from "../../../../../images/Absent.svg";
import ExcelJS from "exceljs";
import Info from "../../../../../images/Information.svg";

import Close from "../../../../../images/Close.svg";
import ReactModal from "react-modal";
import
{
  LoadingStyles,
  ViewPickedSubjectModalStyles,
} from "../../../../../styles/ModalStyles";
import
{
  ExportItemsTemplate,
  ImportItemsDetails,
  ValidateItemsForImport,
} from "./queries/mutations";
import { useLazyQuery, useMutation } from "@apollo/client";
import
{
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import { getDownloadUrl } from "../../../../../utils/DownloadFile";

import useUrlParams from "../../../../../customHooks/useUrlParams";
import * as XLSX from "xlsx";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import LoadingModal from "../../../../pages/LoadingModal";
import MessageModal from "../../../../../customComponents/MessageModal";
import ExcelLoading from "../../../../pages/ExcelLoading";
import { GetItems } from "./queries/queries";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { AtsStckItemOrderField, ItemQueryType } from "./queries/types";
import { removeMoreSpace } from "../../../../../utils/UtilFunctions";
import Validate from "../../../../../images/Validate.svg";
import { CustomTooltip } from "../../../../../styles/TooltipStyles";
import useLabels from "../../../../../customHooks/useLabels";

interface Props
{
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
interface Property
{
  value: string;
  label: string;
  isSelected?: boolean;
}
interface ValidateItemsData
{
  ValidateItemsForImport: boolean;
}
interface ValidateItemsVars
{
  token?: string;
  customerID: string | number;
  desc: string;
}
const ImportItems = ( { setModalFlag }: Props ) =>
{
  const { user_details } = useLoggedInUserDetails();

  const [ records, setRecords ] = useState<any[]>( [] );

  const [ stdConfig, setStdConfig ] = useState( false );
  const [ allSelected, setAllSelected ] = useState( false );
  const [ isIndeterminate, setIsIndeterminate ] = useState( false );
  const [ selectedLedgers, setSelectedLedgers ] = useState<Property[]>( [] );
  const [ message, setMessage ] = useState( emptyMessage );
  const { customer_id, company_id } = useUrlParams();
  const [ importModal, setImportModal ] = useState( false );
  const [ successCount, setSuccessCount ] = useState( 0 );
  const [ errorCount, setErrorCount ] = useState( 0 );

  const [ ValidateEachRow ] = useLazyQuery<ValidateItemsData, ValidateItemsVars>(
    ValidateItemsForImport
  );
  const [ expanded, setExpanded ] = useState( false );

  const stockItemInputsArray: Property[] = [
    { value: "desc", label: "Description" },
    { value: "code", label: "Code" },
    { value: "uom", label: "Unit of Measurement" },
    { value: "enableGst", label: "Enable GST" },
    { value: "igst", label: "Integrated GST" },
    { value: "sgst", label: "State GST" },
    { value: "cgst", label: "Central GST" },
    {
      value: "isStockOrService",
      label: "Is Stock or Service",
    },
    { value: "trackSerial", label: "Track Serial" },
    { value: "trackBatch", label: "Track Batch" },
    { value: "trackBrand", label: "Track Brand" },
    { value: "trackModel", label: "Track Model" },

    { value: "trackExpiry", label: "Track Expiry" },
    { value: "trackWarranty", label: "Track Warranty" },
    {
      value: "trackInstallation",
      label: "Track Installation",
    },
    { value: "trackMaintenance", label: "Track Maintenance" },
    { value: "isPerishable", label: "Is Perishable" },
    { value: "isConsumable", label: "Is Consumable" },
    { value: "imageNeeded", label: "Image Needed" },
    { value: "trackAmc", label: "Track AMC" },
    {
      value: "trackGeoLocation",
      label: "Track Geo-location",
    },
    { value: "trackInsurance", label: "Track Insurance" },
    { value: "isModule", label: "Is Module" },
    { value: "isComponent", label: "Is Component" },
    { value: "image_path", label: "Image Path" },

    {
      value: "stckDetailsEntryIsMultiple",
      label: "Stock Details Entry is Multiple",
    },
    { value: "stckCategoryID", label: "Stock Category ID" },
    { value: "stckGroupID", label: "Stock Group ID" },
    {
      value: "stckManufacturerID",
      label: "Stock Manufacturer ID",
    },
    {
      value: "stckUomID",
      label: "Stock Unit of Measurement ID",
    },
    {
      value: "subCategoryName",
      label: "Sub Category Name",
    },
    {
      value: "hsnCode",
      label: "HSN Code",
    },
    {
      value: "icon",
      label: "Icon",
    },
  ];

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) =>
  {
    const { checked } = event.target;
    setAllSelected( checked );

    if ( checked )
    {
      setSelectedLedgers( stockItemInputsArray );
    } else
    {
      setSelectedLedgers( [] );
    }

    setIsIndeterminate( false );
  };
  const handleLedgerChange = ( property: Property ) =>
  {
    setSelectedLedgers( ( prev ) =>
    {
      if ( prev.some( ( s ) => s.value === property.value ) )
      {
        return prev.filter( ( s ) => s.value !== property.value );
      } else
      {
        return [ ...prev, property ];
      }
    } );
  };
  const [ ImportItemsData, { loading } ] = useMutation( ImportItemsDetails, {
    onError: ( e ) =>
      setMessage( {
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      } ),
  } );
  const [ ExportItems, { loading: AddItemLoading } ] = useLazyQuery(
    ExportItemsTemplate,
    {
      onError: ( e ) =>
      {
        setMessage( {
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        } );
      },
    }
  );
  const displayFileName = (): void =>
  {
    const inputElement = document.getElementById( "input" ) as HTMLInputElement;
    const fileName = inputElement.value;
    const fileLabel = document.getElementById( "file-name" ) as HTMLSpanElement;
    fileLabel.innerHTML = fileName.split( "\\" ).pop()!;
  };
  const handleExport = async () =>
  {
    try
    {
      if ( customer_id )
      {
        const { data, errors } = await ExportItems( {
          variables: {
            customerID: customer_id,
            parameters: selectedLedgers.map( ( res ) => res.value ),
          },
        } );

        if ( data && data.ExportItemsTemplate )
        {
          const res = await getDownloadUrl( data.ExportItemsTemplate, true );
          if ( res )
          {
            setMessage( {
              flag: true,
              message: "Downloading...",
              operation: Operation.CREATE,
            } );
          }
        } else
        {
          setMessage( {
            flag: true,
            message: "Failed downloading file",
            operation: Operation.NONE,
          } );
        }

        if ( errors && errors.length > 0 )
        {
          setMessage( {
            flag: true,
            message: errors[ 0 ].message,
            operation: Operation.NONE,
          } );
        }
      }
    } catch ( err )
    {
      setMessage( {
        flag: true,
        message: ( err as Error ).message,
        operation: Operation.NONE,
      } );
    }
  };
  const totalRecords = useMemo( () =>
  {
    return records.filter( ( record ) => !record.errors ).length;
  }, [ records ] );

  const downloadExcelContainsError = () =>
  {
    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet( "ErrorData" );
    worksheet1.views = [ { state: "frozen", xSplit: 1, ySplit: 1 } ];
    if ( records.length === 0 )
    {
      console.warn( "No data available to create the Excel file." );
      return;
    }

    const errorColumns = [ "errors" ];
    const headers = Object.keys( records[ 0 ] ).filter(
      ( header ) =>
        ![ "isChecked", "isValidated", "isValidatedAndError", "id" ].includes(
          header
        )
    );

    errorColumns.forEach( ( col ) =>
    {
      if ( !headers.includes( col ) )
      {
        headers.push( col );
      }
    } );
    worksheet1.columns = headers.map( ( header ) => ( {
      header,
      key: header,
      width: 20,
    } ) );

    const headerRow = worksheet1.getRow( 1 );
    headerRow.height = 25;
    headerRow.font = { name: "Arial", size: 12, bold: true };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };
    headerRow.eachCell( ( cell ) =>
    {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFE0B2" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    } );

    records
      .filter( ( record ) => record?.errors )
      .forEach( ( entry, rowIndex ) =>
      {
        const row = worksheet1.getRow( rowIndex + 2 );
        headers.forEach( ( header, colIndex ) =>
        {
          const cell = row.getCell( colIndex + 1 );
          cell.value = entry[ header ];
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        } );
      } );

    workbook.xlsx.writeBuffer().then( ( buffer ) =>
    {
      const blob = new Blob( [ buffer ], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      } );
      const url = window.URL.createObjectURL( blob );
      const link = document.createElement( "a" );
      link.href = url;
      link.setAttribute( "download", "StudentInfo.xlsx" );
      document.body.appendChild( link );
      link.click();
      document.body.removeChild( link );
    } );
  };
  const handleAddItems = async () =>
  {
    setSuccessCount( 0 );
    setErrorCount( 0 );
    setImportModal( true );

    try
    {
      for ( const record of records.filter( ( record ) => !record.errors ) )
      {
        try
        {
          await ImportItemsData( {
            variables: {
              customerID: customer_id!,
              user_details,

              input: {
                desc: removeMoreSpace( record.Description ),
                code: removeMoreSpace( record.Code ),
                uom: removeMoreSpace( record.UnitOfMeasurement ),
                hsnCode: removeMoreSpace( record.HNSCode ),
                icon: record.Icon,
                enableGst: record.EnsableGST
                  ? removeMoreSpace( record.EnsableGST.toLowerCase() ) === "no" ||
                    removeMoreSpace( record.EnsableGST.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                igst: record.IGST,
                sgst: record.SGST,
                cgst: record.CGST,
                isStockOrService: record.StockorService
                  ? record.StockorService
                  : EMPTY_STRING,
                trackSerial: record.TrackSerial
                  ? removeMoreSpace( record.TrackSerial.toLowerCase() ) ===
                    "no" ||
                    removeMoreSpace( record.TrackSerial.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                trackBrand: record.TrackBrand
                  ? removeMoreSpace( record.TrackBrand.toLowerCase() ) === "no" ||
                    removeMoreSpace( record.TrackBrand.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                trackModel: record.TrackModel
                  ? removeMoreSpace( record.TrackModel.toLowerCase() ) === "no" ||
                    removeMoreSpace( record.TrackModel.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                trackBatch: record.TrackBatch
                  ? removeMoreSpace( record.TrackBatch.toLowerCase() ) === "no" ||
                    removeMoreSpace( record.TrackBatch.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                trackExpiry: record.TrackExpiry
                  ? removeMoreSpace( record.TrackExpiry.toLowerCase() ) ===
                    "no" ||
                    removeMoreSpace( record.TrackExpiry.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                trackWarranty: record.TrackWarranty
                  ? removeMoreSpace( record.TrackWarranty.toLowerCase() ) ===
                    "no" ||
                    removeMoreSpace( record.TrackWarranty.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                trackInstallation: record.TrackInstallation
                  ? removeMoreSpace( record.TrackInstallation.toLowerCase() ) ===
                    "no" ||
                    removeMoreSpace( record.TrackInstallation.toLowerCase() ) ===
                    "n"
                    ? false
                    : true
                  : false,
                trackMaintenance: record.TrackMaintenance
                  ? removeMoreSpace( record.TrackMaintenance.toLowerCase() ) ===
                    "no" ||
                    removeMoreSpace( record.TrackMaintenance.toLowerCase() ) ===
                    "n"
                    ? false
                    : true
                  : false,
                isPerishable: record.Perishable
                  ? removeMoreSpace( record.Perishable.toLowerCase() ) === "no" ||
                    removeMoreSpace( record.Perishable.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                isConsumable: record.Consumable
                  ? removeMoreSpace( record.Consumable.toLowerCase() ) === "no" ||
                    removeMoreSpace( record.Consumable.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                imageNeeded: record.ImageNeeded
                  ? removeMoreSpace( record.ImageNeeded.toLowerCase() ) ===
                    "no" ||
                    removeMoreSpace( record.ImageNeeded.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                trackAmc: record.TrackAMC
                  ? removeMoreSpace( record.TrackAMC.toLowerCase() ) === "no" ||
                    removeMoreSpace( record.TrackAMC.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                trackGeoLocation: record.TrackGeoLocation
                  ? removeMoreSpace( record.TrackGeoLocation.toLowerCase() ) ===
                    "no" ||
                    removeMoreSpace( record.TrackGeoLocation.toLowerCase() ) ===
                    "n"
                    ? false
                    : true
                  : false,
                trackInsurance: record.TrackInsurance
                  ? removeMoreSpace( record.TrackInsurance.toLowerCase() ) ===
                    "no" ||
                    removeMoreSpace( record.TrackInsurance.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                isModule: record.Module
                  ? removeMoreSpace( record.Module.toLowerCase() ) === "no" ||
                    removeMoreSpace( record.Module.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,
                isComponent: record.Component
                  ? removeMoreSpace( record.Component.toLowerCase() ) === "no" ||
                    removeMoreSpace( record.Component.toLowerCase() ) === "n"
                    ? false
                    : true
                  : false,

                trackCalibration: record.TrackCalibration
                  ? removeMoreSpace( record.TrackCalibration.toLowerCase() ) ===
                    "no" ||
                    removeMoreSpace( record.TrackCalibration.toLowerCase() ) ===
                    "n"
                    ? false
                    : true
                  : false,
                categoryName: record.stckCategoryID,
                subCategoryName: removeMoreSpace( record.subCategoryName ),
                groupName: record.stckGroupID,
                manufacturerName: record.stckManufacturerID,
                uomName: record.stckUomID,
              },
            },
            refetchQueries: [
              {
                query: GetItems,
                variables: {
                  after: null,
                  customerID: customer_id ? customer_id : 0,
                  companyID: company_id ? company_id : 0,
                  first: ROWS_PER_PAGE,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsStckItemOrderField.DESC,
                  },

                  name: EMPTY_STRING,
                  hsnCode: EMPTY_STRING,
                  input: {
                    query_type: ItemQueryType.All,
                    stckCategoryID: 0,
                    stckGroupID: 0,
                    stckManufacturerID: 0,
                    stckUomID: 0,
                    stckSubCategoryID: 0,
                    ldgrID: 0,
                    subsidiaryID: 0,
                  },
                },
              },
            ],
          } ).then( ( { data } ) =>
          {
            if ( data )
            {
              setSuccessCount( ( prev ) => prev + 1 );
            }
          } );
        } catch ( error )
        {
          console.error( error );
          setErrorCount( ( prev ) => prev + 1 );
        }
      }
    } catch ( err )
    {
      console.error( "Error fetching token:", err );
      setMessage( {
        flag: true,
        message: ( err as Error ).message || "Failed to fetch token",
        operation: Operation.NONE,
      } );
    }
  };

  useEffect( () =>
  {
    setIsIndeterminate(
      selectedLedgers.length > 0 &&
      selectedLedgers.length < stockItemInputsArray.length
    );
    setAllSelected( selectedLedgers.length === stockItemInputsArray.length );
  }, [ selectedLedgers ] );
  const handleClose = () =>
  {
    if ( message.operation !== Operation.NONE )
    {
      setModalFlag( false );
    }
    setMessage( {
      message: "",
      flag: false,
      operation: Operation.NONE,
    } );
  };
  const item_schema = {
    Description: {
      Headers: "Description",
      key: "desc",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Code: {
      Headers: "Code",
      key: "code",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    UnitOfMeasurement: {
      Headers: "Unit of Measurement",
      key: "uom",
      width: 50,
      required: false,
      use_in_sheet: true,
    },

    EnsableGST: {
      Headers: "Enable GST",
      key: "enableGst",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    IGST: {
      Headers: "Integrated GST",
      key: "igst",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    SGST: {
      Headers: "State GST",
      key: "sgst",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    CGST: {
      Headers: "Central GST",
      key: "cgst",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    StockorService: {
      Headers: "Is Stock or Service",
      key: "isStockOrService",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TrackSerial: {
      Headers: "Track Serial",
      key: "trackSerial",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TrackBrand: {
      Headers: "Track Braand",
      key: "trackBrand",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TrackModel: {
      Headers: "Track Model",
      key: "trackModel",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TrackBatch: {
      Headers: "Track Batch",
      key: "trackBatch",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TrackExpiry: {
      Headers: "Track Expiry",
      key: "trackExpiry",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TrackWarranty: {
      Headers: "Track Warranty",
      key: "trackWarranty",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TrackInstallation: {
      Headers: "Track Installation",
      key: "trackInstallation",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TrackMaintenance: {
      Headers: "Track Maintenance",
      key: "trackMaintenance",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Perishable: {
      Headers: "Is Perishable",
      key: "isPerishable",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Consumable: {
      Headers: "Is Consumable",
      key: "isConsumable",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    ImageNeeded: {
      Headers: "Image Needed",
      key: "imageNeeded",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TrackAMC: {
      Headers: "Track AMC",
      key: "trackAmc",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TrackGeoLocation: {
      Headers: "Track Geo-location",
      key: "trackGeoLocation",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TrackInsurance: {
      Headers: "Track Insurance",
      key: "trackInsurance",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Module: {
      Headers: "Is Module",
      key: "isModule",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Component: {
      Headers: "Is Component",
      key: "isComponent",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    image_path: {
      Headers: "Image Path",
      key: "image_path",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    stckDetailsEntryIsMultiple: {
      Headers: "Stock Details Entry is Multiple",
      key: "stckDetailsEntryIsMultiple",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    stckCategoryID: {
      Headers: "Stock Category ID",
      key: "stckCategoryID",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    stckGroupID: {
      Headers: "Stock Group ID",
      key: "stckGroupID",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    stckManufacturerID: {
      Headers: "Stock Manufacturer ID",
      key: "stckManufacturerID",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    stckUomID: {
      Headers: "Stock Unit of Measurement ID",
      key: "stckUomID",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    subCategoryName: {
      Headers: "Sub Category Name",
      key: "subCategoryName",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    HNSCode: {
      Headers: "HSN Code",
      key: "hsnCode",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Icon: {
      Headers: "Icon",
      key: "icon",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
  };

  const schemaKeys = Object.keys( item_schema );

  const processExcel = ( data: any ) =>
  {
    const workbook = XLSX.read( data, { type: "binary" } );
    const firstSheet = workbook.SheetNames[ 0 ];
    const records = XLSX.utils.sheet_to_json( workbook.Sheets[ firstSheet ] );
    records.forEach( ( record: any ) =>
    {
      let errors: any = [];

      Object.keys( item_schema ).forEach( ( key ) =>
      {
        // @ts-ignore
        let keySchema = item_schema[ key ];
        let keyValue = record[ key ];

        if (
          keySchema?.required &&
          ( keyValue === null || keyValue === undefined )
        )
        {
          let errorObj = {
            column: key,
            error: "Required",
          };
          errors.push( errorObj );
        }
      } );

      if ( errors.length > 0 )
      {
        record.errors = errors;
      }
    } );

    return records;
  };

  useEffect( () =>
  {
    const input = document.getElementById( "input" ) as HTMLInputElement;
    if ( input )
    {
      input.addEventListener( "change", () =>
      {
        const reader = new FileReader();
        reader.onload = ( e ) =>
        {
          const res = processExcel( reader.result );
          setRecords(
            res.map( ( f: any, index: number ) =>
            {
              return {
                ...f,
                id: index + 1,
                isChecked: false,
                isValidated: false,
                isValidatedAndError: false,
              };
            } )
          );
        };
        reader.readAsBinaryString( input.files![ 0 ] );
      } );
    }
  } );
  const handleButtonClick = async () =>
  {
    try
    {
      await Promise.all( records.map( ( record ) => handleClick( record.id ) ) );
    } catch ( error )
    {
      console.error( error );
    }
  };

  const handleClick = async ( id: number ) =>
  {
    try
    {
      const filteredData = records.find( ( record ) => record.id === id );

      if ( filteredData )
      {
        const { data, errors } = await ValidateEachRow( {
          variables: {
            customerID: customer_id!,

            desc: removeMoreSpace( filteredData.Description ),
          },
        } );

        if ( data )
        {
          const newData = records.map( ( record ) =>
          {
            if ( id === record.id )
            {
              return {
                ...record,
                isChecked: !record?.isChecked,
                isValidated: !record.isValidated,
                isValidatedAndError: false,
              };
            }
            return record;
          } );
          setRecords( newData );
          return Promise.resolve( data );
        }

        if ( errors && errors.length > 0 )
        {
          const newData = records.map( ( record ) =>
          {
            if ( record.id === id )
            {
              record.errors = record.errors ? record.errors : [];
              record.errors.push( errors[ 0 ]?.message );
              return {
                ...record,
                isChecked: !record?.isChecked,
                isValidated: true,
                isValidatedAndError: true,
              };
            }
            return record;
          } );
          setRecords( newData );
          return Promise.reject( errors[ 0 ] );
        }
      }
    } catch ( err )
    {
      setMessage( {
        flag: true,
        message: ( err as Error ).message || "An error occurred",
        operation: Operation.NONE,
      } );
      return Promise.reject( err );
    }
  };
  const { itemLabel } = useLabels();
  return (
    <>
      <div className="import-excel-data__modal">
        <div className="import-excel-data--title">
          <Title>Import {itemLabel}</Title>
          <img src={Close} alt="" onClick={() => setModalFlag( false )} />
        </div>
        <div className="row g-0 import-excel-data__blocks">
          <div className="col-6">
            <div className="import-excel-data__file-upload">
              <div className="import-excel-data__file-upload--file-name">
                <span id="file-name"></span>
              </div>
              <div className="import-excel-data__file-upload--browse">
                <label htmlFor="input">
                  <img src={FileAttach} alt="/" /> Choose Excel File
                </label>
                <input
                  id="input"
                  type="file"
                  name="file"
                  onChange={() => displayFileName()}
                  className="import-excel-data__file-upload--input"
                />
              </div>
            </div>
          </div>

          <div className="col import-excel-data__blocks--cards">
            <b>
              <img src={TotalStudents} alt="/" />
              Total {itemLabel}
            </b>
            <span className="import-excel-data__blocks--cards--total-students">
              {records.length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
          // onClick={() => setExpanded(!expanded)}
          >
            <b>
              <img src={ReadyToImport} alt="/" />
              Ready to Import
            </b>
            <span className="import-excel-data__blocks--cards--ready-to-import">
              {records.filter( ( record ) => !record.errors ).length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
            onClick={() => setExpanded( !expanded )}
          >
            <b>
              <img src={ContainsError} alt="/" />
              Contains Error
            </b>
            <span className="import-excel-data__blocks--cards--contains-error">
              {records.filter( ( record ) => record?.errors ).length}
            </span>
          </div>
        </div>
        <div className="import-excel-data__datablock">
          {records.length > 0 ? (
            <>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded( !expanded )}
              >
                <div className="import-excel-data__datablock--records-count">
                  <span>
                    {records.filter( ( record ) => !record.errors ).length}
                  </span>
                  <b> Records Found to Import</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              <div className="import-excel-data__datablock--tableblock">
                <TableContainer className="import-excel-data__datablock--table">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell id="td-center">
                          {TableHeaders.SLNO}
                        </TableCell>
                        {schemaKeys
                          .filter( ( key ) =>
                            records.some( ( record ) => key in record )
                          )
                          .map( ( key, index ) => (
                            <TableCell key={index}>{key}</TableCell>
                          ) )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {records
                        .filter( ( record ) => !record?.errors )
                        .map( ( record, index ) => (
                          <TableRow key={index}>
                            <TableCell id="td-center">{index + 1}</TableCell>
                            {schemaKeys
                              .filter( ( key ) => key in record )
                              .map( ( key, colIndex ) => (
                                <TableCell key={colIndex}>
                                  {record[ key ]}
                                </TableCell>
                              ) )}
                          </TableRow>
                        ) )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded( !expanded )}
              >
                <div className="import-excel-data__datablock--errors-count">
                  <span>{records.filter( ( d ) => d?.errors ).length}</span>
                  <b>Records Which Contains error(s)</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              {expanded && (
                <div className="import-excel-data__datablock--tableblock">
                  <TableContainer className="import-excel-data__datablock--table">
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell id="td-center">
                            {TableHeaders.SLNO}
                          </TableCell>
                          {schemaKeys
                            .filter( ( key ) =>
                              records.some( ( record ) => key in record )
                            )
                            .map( ( key, index ) => (
                              <TableCell key={index}>{key}</TableCell>
                            ) )}
                          <TableCell id="td-center">Error Details</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {records
                          .filter( ( record ) => record?.errors )
                          .map( ( record, index ) =>
                          {
                            return (
                              <TableRow key={index}>
                                <TableCell id="td-center">
                                  {index + 1}
                                </TableCell>
                                {schemaKeys
                                  .filter( ( key ) => key in record )
                                  .map( ( key, colIndex ) => (
                                    <TableCell key={colIndex}>
                                      {record[ key ]}
                                    </TableCell>
                                  ) )}

                                <TableCell className="import-excel-data__datablock--error">
                                  <CustomTooltip
                                    title={
                                      <ul>
                                        {record?.errors
                                          ? record?.errors?.map(
                                            ( error: any, index: number ) =>
                                            {
                                              return (
                                                <li key={index}>
                                                  {index + 1})&nbsp;
                                                  {typeof error === "string"
                                                    ? error
                                                    : "Error message = " +
                                                    error.error +
                                                    ", column = " +
                                                    error.column}
                                                </li>
                                              );
                                            }
                                          )
                                          : null}
                                      </ul>
                                    }
                                    arrow
                                    placement="bottom-start"
                                  >
                                    <div className="import-excel-data__datablock--tableblock--error-message">
                                      <span>Errors</span>
                                      <img src={Info} alt="/" />
                                    </div>
                                  </CustomTooltip>
                                </TableCell>
                              </TableRow>
                            );
                          } )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </>
          ) : null}
        </div>
        <div className="row g-0">
          <div className="col">
            <Button
              onClick={() =>
              {
                setImportModal( true );
                handleAddItems();
              }}
              disabled={!records.length ? true : false}
              mode="excel"
            >
              Import
            </Button>
            <Button onClick={handleButtonClick}>
              <img src={Validate} alt="" />
              Validate
            </Button>
            <Button onClick={downloadExcelContainsError} mode="excel">
              Export error Data
            </Button>
            <Button mode="cancel" onClick={() => setModalFlag( false )} />
          </div>
          <div className="col-3 import-excel-data__button">
            <Button mode="excel" onClick={() => setStdConfig( true )}>
              Generate Template XLS File
            </Button>
          </div>
        </div>
      </div>

      <ReactModal
        shouldCloseOnOverlayClick={true}
        isOpen={importModal}
        style={LoadingStyles}
        ariaHideApp={false}
        onRequestClose={() => setImportModal( !importModal )}
      >
        <ExcelLoading
          total={totalRecords}
          success={successCount}
          errors={errorCount}
          loading={loading}
          setModalFlag={setImportModal}
        />
      </ReactModal>
      <LoadingModal flag={AddItemLoading} />
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
      <ReactModal
        shouldCloseOnOverlayClick={true}
        isOpen={stdConfig}
        style={ViewPickedSubjectModalStyles}
        ariaHideApp={false}
      >
        <div className="import-excel-data__receipts">
          <div className="import-excel-data__receipts--title">
            <Title>Choose Properties</Title>
            <img
              src={Close}
              alt="/"
              className="modal-close-icon"
              onClick={() => setStdConfig( !stdConfig )}
            />
          </div>

          <div className="import-excel-data__receipts--block">
            <div className="select-all">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="allSelect"
                      className="select-all--checkbox"
                      checked={allSelected}
                      indeterminate={isIndeterminate}
                      onChange={handleSelectAllChange}
                    />
                  }
                  label="Select All"
                />
              </FormGroup>
            </div>

            {stockItemInputsArray &&
              stockItemInputsArray.map( ( property, index ) => (
                <FormGroup className="select-all__checkboxes" key={index}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={property.value}
                        checked={selectedLedgers.some(
                          ( s ) => s.value === property.value
                        )}
                        onChange={() => handleLedgerChange( property )}
                      />
                    }
                    label={
                      <>
                        &nbsp; {index + 1}) &nbsp; {property.label}
                      </>
                    }
                  />
                </FormGroup>
              ) )}
          </div>

          <Button mode="excel" onClick={handleExport}>
            Download To Excel
          </Button>

          <Button mode="cancel" onClick={() => setStdConfig( !stdConfig )} />
        </div>
      </ReactModal>
    </>
  );
};

export default ImportItems;
